module.exports = __webpack_public_path__ + "img/logo.2b3d3f0d.webp";